/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.ursascheduler.OverlapPolicy
*/
export var OverlapPolicy;
(function (OverlapPolicy) {
    OverlapPolicy["SKIP"] = "SKIP";
    OverlapPolicy["QUEUE"] = "QUEUE";
    OverlapPolicy["CANCEL_PREVIOUS"] = "CANCEL_PREVIOUS";
})(OverlapPolicy || (OverlapPolicy = {}));
//# sourceMappingURL=OverlapPolicy.js.map